<template>
    <div>
        <div class="row">
            <div class="col-md-12 ts-flex">
                <div class="col-md-6">
                    <label>{{ $t('studentScoringEntry.weight') }}</label>
                    <div>
                        <input v-model="model.weight" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-md-6">
                    <label>{{ $t('studentScoringEntry.height') }}</label>
                    <div>
                        <input v-model="model.height" type="text" class="form-control">
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12 ts-flex">
                <div class="col-md-6">
                    <label>{{ $t('studentScoringEntry.personalHygiene') }}</label>
                    <div>
                        <textarea v-model="model.personal_hygiene" class="form-control" rows="5"></textarea>
                    </div>
                </div>
                <div class="col-md-6">
                    <label>{{ $t('studentScoringEntry.advice') }}</label>
                    <div>
                        <textarea v-model="model.advice" class="form-control" rows="5"></textarea>

                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12 text-right">
                <ts-button @click.prevent="$emit('closeModal')">
                    {{ $t('cancel') }}
                </ts-button>

                <ts-button v-if="model.id == 0" class="ml-2" color="primary" @click.prevent="ratingScaleSave"
                    :waiting="save_rating_scale">
                    {{ $t('save') }}
                </ts-button>
                <ts-button v-if="model.id != 0" color="primary" :waiting="waiting" @click.prevent="onUpdate">{{
                    $t('update') }}</ts-button>
            </div>
        </div>
    </div>
</template>
<script>
import { Errors } from 'form-backend-validation'

export default {
    name: 'rating-scale',
    props: ['value'],
    data() {
        return {
            model: {
                weight: null,
                height: null,
                personal_hygiene: null,
                advice: null,
                student_id: null,
                id: 0
            },
            errors: new Errors(),
            save_rating_scale: false,
            waiting: false
        }
    },
    created() {
        this.model.student_id = this.value.student_id
        this.fetchRatingScal()
    },
    methods: {
        ratingScaleSave() {
            this.errors = new Errors()
            this.save_rating_scale = true
            this.$store
                .dispatch('studentScoringEntry/saveRatingScale', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.save_rating_scale = false
                    this.clearForm()
                    this.$emit('closeModal')
                })
                .catch(error => {
                    this.save_rating_scale = false
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
        },
        fetchRatingScal() {
            this.loading = true
            this.$store
                .dispatch('studentScoringEntry/findRatingScal', {
                    params: {
                        student_id: this.value.student_id,
                        id: this.value.id
                    }
                })
                .then(response => {
                    if (response.data) {
                        this.model.weight = response.data.weight
                        this.model.height = response.data.height
                        this.model.personal_hygiene = response.data.personal_hygiene
                        this.model.advice = response.data.advice
                        this.model.id = response.data.id
                    }
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onUpdate() {
            this.waiting = true
            this.$store
                .dispatch('studentScoringEntry/updateRatingScale', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.clearForm()
                    this.$emit('closeModal')
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        clearForm() {
            this.model = {
                weight: null,
                height: null,
                personal_hygiene: null,
                advice: null,
                student_id: null,
            }
        }
    }
}
</script>